import React from 'react'
import { Segment, Header, Icon, Divider } from 'semantic-ui-react'
import Relatorio from './RelatorioForm'
import SwitchRouter from 'components/SwitchRouter'
import { Route } from 'react-router-dom'

export default function Inicio({ match: { path } }) {

    return (
        <div className='page-content'>
            <Segment className='subcontent'>
                <div className="row mx-0">
                    <div className="col">
                        <Header as='h3'>
                            <Icon.Group size='big'>
                                <Icon name='file alternate outline' className='primary-color' />
                            </Icon.Group>
                            <Header.Content className='primary-color'>
                                Relatório de Contas a Pagar <Header.Subheader className='secondary-color'>Menu</Header.Subheader>
                            </Header.Content>
                        </Header>
                    </div>
                </div>
                <Divider className='mt-2 custom-divider darken' fitted />
                <div className="row flex-grow-1 flex-column">
                    <SwitchRouter>
                        <Route exact path={`${path}`} render={props => <Relatorio {...props} path={path} />} />
                    </SwitchRouter>
                </div>
            </Segment>
        </div>
    )
}